export default __webpack_public_path__ + "static/sentinel-banner-monitor-all-9a7c188b846d7a0ebf50b98e8957bebf.jpg";